import { SvgIcon, SvgIconProps } from '@mui/material';

export default function CsvDownloadIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5777 7.74392L10.8337 10.488V1.6665H9.16699V10.488L6.42291 7.74392L5.2444 8.92243L10.0003 13.6783L14.7562 8.92243L13.5777 7.74392ZM18.3337 16.6665V13.3332H16.667V16.6665H3.33366V13.3332H1.66699V16.6665C1.66699 17.587 2.41318 18.3332 3.33366 18.3332H16.667C17.5875 18.3332 18.3337 17.587 18.3337 16.6665Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}
